import { render } from "./splash_page.vue?vue&type=template&id=166b3ca8&scoped=true"
import script from "./splash_page.vue?vue&type=script&lang=js"
export * from "./splash_page.vue?vue&type=script&lang=js"

import "./splash_page.vue?vue&type=style&index=0&id=166b3ca8&lang=css"
import "./splash_page.vue?vue&type=style&index=1&id=166b3ca8&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166b3ca8"]])

export default __exports__